import React from "react";
import { StyledListContainer } from "../../../styles/pages/AdministratorTach/AdministratorTachStyles";
import CardList from "./CardList";
import CardListContent from "./CardListContent";
import { useAdministratorTach } from "../../../context/AdministratorTachContext";
import GenerateTach from "../GenerateTach/GenerateTach";
import PaginationServerSide from "../../../components/PaginationServerSide";
import { useFilterData } from "../../../context/TachContext/FilterDataContext";

const List = () => {
    const {
        isCreatedSubprocess,
        subprocess,
        getSubprocessos,
        pagination,
        setPagination,
    } = useAdministratorTach();
    const { filterPage } = useFilterData();

    const handleChangePage = (actualPage: number) => {
        const filter = {
            ...pagination,
            actualPage,
        };

        setPagination(filter);
        getSubprocessos(filterPage, filter);
    };

    return isCreatedSubprocess ? (
        <StyledListContainer>
            <PaginationServerSide
                pagination={pagination}
                filterPageSize={pagination.sizePage}
                handleChangePage={handleChangePage}
            >
                {subprocess.map((row) => (
                    <CardList
                        name={row.docente.nome}
                        date={row.created}
                        key={row.id}
                    >
                        <CardListContent
                            historyTerm={row.termoHistorico}
                            subprocessId={row.id}
                            status={row.status}
                            name={row.docente.nome}
                            matriculaAdp={row.docente.matriculaAdp}
                        />
                    </CardList>
                ))}
            </PaginationServerSide>
        </StyledListContainer>
    ) : (
        <GenerateTach />
    );
};

export default List;
